import React from "react";
import { Typography, Box, Button } from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { SiGmail, SiPaypal } from "react-icons/si";

const glass = {
  background: "rgba(255, 255, 255, 0.16)",
  backdropFilter: "blur(18px)",
  WebkitBackdropFilter: "blur(18px)",
  border: "1px solid rgba(255, 255, 255, 0.35)",
  boxShadow: "0 20px 60px rgba(8, 40, 90, 0.25)",
};

const Support = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ position: "relative", px: 2, py: { xs: 4, sm: 8 } }}>
      {/* Decorative blobs */}
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          top: 0,
          right: "12%",
          width: 260,
          height: 260,
          borderRadius: "50%",
          background: "#ff6fb5",
          opacity: 0.35,
          filter: "blur(90px)",
          pointerEvents: "none",
        }}
      />
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          bottom: 0,
          left: "10%",
          width: 280,
          height: 280,
          borderRadius: "50%",
          background: "#7c5cff",
          opacity: 0.4,
          filter: "blur(100px)",
          pointerEvents: "none",
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Box
          sx={{
            ...glass,
            position: "relative",
            zIndex: 1,
            maxWidth: 680,
            mx: "auto",
            borderRadius: { xs: "24px", sm: "32px" },
            p: { xs: 3, sm: 6 },
            color: "#fff",
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              mx: "auto",
              mb: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "rgba(255,255,255,0.22)",
              border: "1px solid rgba(255,255,255,0.4)",
            }}
          >
            <FavoriteBorderIcon sx={{ fontSize: 34 }} />
          </Box>

          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 800,
              letterSpacing: "-0.02em",
              textAlign: "center",
              mb: 3,
              fontSize: { xs: "1.9rem", sm: "2.4rem" },
              textShadow: "0 2px 18px rgba(8,40,90,0.35)",
            }}
          >
            {t("support")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 2,
              lineHeight: 1.75,
              color: "rgba(255,255,255,0.93)",
              fontSize: { xs: "0.97rem", sm: "1.07rem" },
            }}
          >
            {t("support_p1")}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 2,
              lineHeight: 1.75,
              color: "rgba(255,255,255,0.93)",
              fontSize: { xs: "0.97rem", sm: "1.07rem" },
            }}
          >
            {t("support_p2")}
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "center",
              gap: 2,
              mt: 4,
            }}
          >
            <Button
              variant="outlined"
              startIcon={<SiGmail />}
              href="mailto:pravitas.dev@gmail.com"
              sx={{
                borderRadius: "50px",
                textTransform: "none",
                fontWeight: 600,
                px: 4,
                py: 1.2,
                color: "#fff",
                borderColor: "rgba(255,255,255,0.7)",
                borderWidth: 2,
                transition: "all .2s ease",
                "&:hover": {
                  borderColor: "#fff",
                  borderWidth: 2,
                  background: "rgba(255,255,255,0.15)",
                  transform: "translateY(-2px)",
                },
              }}
            >
              Gmail
            </Button>

            <Button
              variant="contained"
              startIcon={<SiPaypal />}
              href="https://www.paypal.com/paypalme/hpravitas"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                borderRadius: "50px",
                textTransform: "none",
                fontWeight: 700,
                px: 4,
                py: 1.2,
                color: "#fff",
                background: "#0070ba",
                boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                transition: "all .2s ease",
                "&:hover": {
                  background: "#005c95",
                  transform: "translateY(-2px)",
                  boxShadow: "0 14px 36px rgba(0,0,0,0.3)",
                },
              }}
            >
              PayPal
            </Button>
          </Box>
        </Box>
      </motion.div>
    </Box>
  );
};

export default Support;
